<ol class="step-indicator" role="list" [attr.aria-label]="ariaLabel()">
  @for (step of stepViews(); track step.number; let last = $last) {
    <li class="step-indicator__item"
        role="listitem"
        [attr.aria-current]="step.state === 'active' ? 'step' : null"
        [attr.data-state]="step.state">
      <div class="step-indicator__node">
        <span class="step-indicator__circle" aria-hidden="true">
          @if (step.state === 'complete') {
            <i class="bx bx-check"></i>
          } @else {
            {{ step.number }}
          }
        </span>
        <span class="step-indicator__label">{{ step.label }}</span>
      </div>
      @if (!last) {
        <span class="step-indicator__bar" aria-hidden="true"></span>
      }
    </li>
  }
</ol>
